import {
  formatApDateTime,
  formatApZonedDateTime,
} from "@/accounts-payable/utils";
import { useApBusinessTimeZone } from "./use-ap-business-time-zone";

export const ZonedDateTime = ({
  value,
  className,
}: {
  value: string | null | undefined;
  className?: string;
}) => {
  const timeZone = useApBusinessTimeZone();
  return (
    <span title={formatApZonedDateTime(value, timeZone)} className={className}>
      {formatApDateTime(value, timeZone)}
    </span>
  );
};
